import React from 'react';
import { Col, Row } from 'antd';
import { useAuth, useResources } from '@BUP/hooks';
import { ResourceBupList } from '@BUP/components';
import { ECE, ASSISTANT, TEACHER } from '@BUP/constants';
import styles from './resources-bup-panel.module.css';

const ResourcesBupPanel = ({ title }) => {
  const {
    isLoading: loadingResources,
    data: resources,
    error: errorResources,
  } = useResources();
  const { user } = useAuth();
  const roleType = user?.roles.type;
  return (
    <div>
      <Row>
        <Col>
          <h3 className={styles.title}>{title}</h3>
        </Col>
      </Row>
      <Row className={styles.container}>
        {roleType === ECE || roleType === ASSISTANT || roleType === TEACHER ? (
          <ResourceBupList
            resources={resources}
            loadingResources={loadingResources}
            errorResources={errorResources}
          />
        ) : (
          resources.map((resource) => (
            <ResourceBupList
              resource={resource}
              resources={resources}
              key={resource?.id}
            />
          ))
        )}
      </Row>
    </div>
  );
};

export default ResourcesBupPanel;
